const aTraiterValueGetter = (params) => (params.data.to_be_handled === 1 ? "Oui" : "");

export default aTraiterValueGetter;